import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/signing-requests')({
  staticData: {
    breadcrumb: 'Signing Requests',
    breadcrumbKey: 'K_BREADCRUMB_SIGNING_REQUESTS',
  },
});
